import isNil from "lodash/fp/isNil";
import isString from "lodash/fp/isString";
import constants from "../../core/constants";
class Controller {
  constructor($injector, $mdDialog, Events, Upload) {
    "ngInject";

    this.Events = Events;
    this.Upload = Upload;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.requestFileUrlEvent = this.Events.eventsType.onRequestFileUrlEvent;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.Messages = $injector.get("Messages");
    this.validate = this.validate.bind(this);
  }
  $onInit() {
    this.files = this.previouslyAdded(this.files);
    this.validationMsg =
      !isNil(this.validation) && Array.isArray(this.validation)
        ? `Available extensions  (${this.validation.join(", ")}).`
        : `File extension should follow this pattern ${this.validation}.`;
    this.validationErrors = [];
  }
  $onChanges() {
    if (this.files && this.files.length > 0) {
      this.files = this.previouslyAdded(this.files);
    }
  }

  previouslyAdded(files) {
    return files && files.length
      ? files.map((f) => {
          if (!isNaN(f)) {
            return { key: f, isObject: true };
          } else if (isString(f)) {
            return { url: f, name: f, isObject: false };
          }
          return f;
        })
      : [];
  }

  addMarker(file) {
    const isImageOrPdf = /(\.)(p(df|ng)|jp(e)?g)$/gi.test(file.name);
    return Object.assign({}, { source: file, isImageOrPdf, newlyAdded: true });
  }

  getIsMultipleText() {
    return this.allowMultiple ? "All" : "";
  }
  getFileObject(file) {
    const { isObject, ...s3FileObject } = file;
    this.Events.emit(this.requestFileUrlEvent, s3FileObject);
  }
  addFile() {
    if (!isNil(this.file)) {
      this.validationErrors = [];
      let fileSize = this.file.size;
      if (!isNil(this.sizeUnit) && this.sizeUnit === "MB") {
        fileSize /= constants.fromMegaToByte;
      }
      if (fileSize > this.maxSize) {
        this.validateMaxSize(this.maxSize, this.sizeUnit);
      } else if (this.allowMultiple && this.file.length > 0) {
        this.files.push(...this.file.filter(this.validate).map(this.addMarker));
      } else if (!this.allowMultiple && this.file.size) {
        this.files = this.validate(this.file) && [this.addMarker(this.file)];
      }
      this.Events.emit(this.addFileEventName, this.files);
    }
  }

  validate(file) {
    if (isNil(this.validation)) {
      return true;
    }
    const extension = file.name.match(/\.[^.]+$/gi);
    const errorMsg = `${file.name} not supported`;
    let valid = false;
    if (Array.isArray(this.validation)) {
      valid = !isNil(extension) && this.validation.includes(extension[0]);
    } else if (this.validation.test) {
      // RegexExp
      valid = !isNil(extension) && this.validation.test(extension[0]);
    }
    if (!valid) this.validationErrors.push(errorMsg);
    return valid;
  }

  validateMaxSize(maxSize, unit) {
    this.sizeErrorMsg =
      "Can't upload file exceeds maximum size: " + maxSize + unit;
    this.validationErrors.push(this.sizeErrorMsg);
  }

  toggleExpand() {
    if (!this.isDisabled) {
      this.expanded = !this.expanded;
    }
  }

  handleRemove(file) {
    const fileIndex = this.files.findIndex((f) => f.name === file.name);
    this.files.splice(fileIndex, 1);

    this.Events.emit(this.showSuccessNotificationEvent, {
      message: "The file is removed successfully",
    });
  }

  confirmRemove(file) {
    const confirmationDialog = this.$mdDialog
      .confirm()
      .title("Are you sure you want to remove this document?")
      .ok("Ok")
      .cancel("Cancel");

    this.$mdDialog.show(confirmationDialog).then(() => {
      this.remove(file);
    }, angular.noop);
  }

  remove(file) {
    if (file.newlyAdded) {
      this.handleRemove(file);
    } else {
      const resource = this.$injector.get(this.resource);
      const resourceRemoveMethod = resource[this.resourceRemoveMethod].bind(
        resource
      );
      const { isObject, contentType, originalName, ...s3FileObject } = file;
      let params = {};
      if (isObject) {
        params = s3FileObject;
        params.type = this.type;
      } else {
        params = {
          document: file.url,
          type: this.type,
        };
      }
      resourceRemoveMethod(
        this.resourceId,
        params
      ).$promise.then(this.handleRemove.bind(this, file), (response) =>
        this.Events.emit(this.errorEvent, response.data)
      );
    }
  }

  upload() {
    const toUpload = this.files.filter((f) => f.newlyAdded);
    const resource = this.$injector.get(this.resource);
    const resourceMethod = resource[this.resourceMethod].bind(resource);

    toUpload.forEach((file) => {
      resourceMethod(this.resourceId, {
        [this.documentKey || "document"]: file.source,
        type: this.type,
      }).$promise.then(
        (response) => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: `${this.title} is uploaded successfully`,
          });
          this.Events.emit(this.uploadDoneEventName, response.data);
        },
        (response) =>
          this.Events.emit(this.Events.eventsType.onShowErrorNotification, {
            message:
              !isNil(response.data) && !isNil(response.data.message)
                ? response.data.message
                : response.statusText,
          })
      );
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableDocuments/editableDocuments.controller.js